import { DataType, MetadataColumn, MetadataTable } from '@bechtel/sr-types';
import { filter, find, isNil, upperFirst } from 'lodash';
import { date, number, string } from 'yup';

export function getDataType(type: string) {
  switch (type) {
    case DataType.STRING:
      return string();
    case DataType.NUMBER:
      return number();
    case DataType.DATE:
      return date();
    default:
      return string();
  }
}

export const formatValues = <T>(data: T, metadataColumns: MetadataColumn[]): T | undefined => {
  if (!data || !metadataColumns) return;
  const formData = { ...data };
  // Transform null to empty string for all the properties of the object
  for (const key in formData) {
    const matchingColumn = metadataColumns.find((col) => col.memberName === key);
    if (isNil(formData[key])) {
      formData[key] = '';
    }
    if (key != 'latitude' && key != 'longitude' && key != 'elevation') {
      if (matchingColumn && matchingColumn.dataType === DataType.NUMBER) {
        // Round the value to the specified decimal places
        const roundedValue = Number(formData[key]).toFixed(matchingColumn.decimals).toString();
        formData[key] = roundedValue;
      }
    }
  }
  return formData;
};

export const getDescription = (data, isAlternateLanguageUsed, memberName) => {
  const metadataColumn = find(data, (item) => item.memberName === memberName);
  return metadataColumn
    ? isAlternateLanguageUsed
      ? metadataColumn?.alternateDescription
      : metadataColumn?.description
    : '';
};

export const getDecimalsValueByMemberName = (tableMetadata: MetadataTable, targetMemberName: string): number => {
  const filteredColumns = filter(tableMetadata.metadataColumns, (column) => {
    return column.memberName === targetMemberName;
  });
  const decimalsValue = filteredColumns.length > 0 ? filteredColumns[0].decimals : 0;
  return decimalsValue;
};

export const getCommodityRowQueryName = (tableMemberName: string): string => {
  return `search${upperFirst(tableMemberName)}s`;
};
